<script setup lang="ts">
import { computed } from "vue";

import type { DictsysArticle } from "@/types";

const props = defineProps<{
  article: DictsysArticle;
}>();

const message = computed<string>(() => {
  const prefix = props.article.prefix;

  switch (prefix?.type) {
    case "loose-conjugation":
      return props.article.usageLanguage === "da"
        ? `“${prefix.query}” kan også være en del af dette løst sammensatte verbum`
        : `„${prefix.query}“ kann auch Teil dieses trennbaren Verbs sein`;

    case "inflected-form":
      return props.article.usageLanguage === "da"
        ? `“${prefix.inflectedForm}” er en bøjet form af “${prefix.headWord}”`
        : `„${prefix.inflectedForm}“ ist eine gebeugte Form von „${prefix.headWord}“`;

    default:
      return "";
  }
});
</script>

<template>
  <div v-if="message" class="le-article-prefix">
    {{ message }}
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
@import "@/assets/styles/dictsys-article";

.le-article-prefix {
  padding: 9px 27px;
  border-radius: 4px 4px 0 0;
  background: @colors[@primary][100];
  color: @colors[@neutrals][300];
  .dictsys-article-text();
}
</style>
